import { appActions } from '../AppActions'
import EventScheduleRepository from '../../infra/EventScheduleRepository'

const onRequestUpdate = async eventScheduleState => {
  const res = await EventScheduleRepository.requestUpdate(eventScheduleState).catch(e => e)
  if (res instanceof Error) {
    appActions.showAlert(res, '更新に失敗しました')
    return false
  }

  appActions.snackbar('更新しました', 'success', true)
  return true
}

export default onRequestUpdate
